import { Breakpoints } from '@volkswagen-onehub/components-core';
import React from 'react';
import { Grid } from './grid';
import { Group } from './group';

interface Props {
	children: React.ReactNode;
	marginTop?: string;
	marginBottom?: string;
}

export function CardsGroup(props: Props) {
	const { children } = props;

	return (
		<Group {...props}>
			<Grid
				allowOverflowingContent
				appearance={{
					[Breakpoints.default]: [{ name: 'a', columns: 24 }],
					[Breakpoints.b560]: [{ name: 'a', columns: 12 }],
				}}
				rowGap="24px"
			>
				{children}
			</Grid>
		</Group>
	);
}
